/* Montvail premium interactions */
(function () {
  var root = document.documentElement;
  var SHOP_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BAG_SVG = '<svg class="mv-bag" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 7h3V6a4 4 0 1 1 8 0v1h3v12.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5V7Zm5 0h4V6a2 2 0 1 0-4 0v1Z"/></svg>';

  var ticking = false;
  function setScrollState() { var y = window.pageYOffset || root.scrollTop || 0; root.classList.toggle('mv-scrolled', y > 40); ticking = false; }
  window.addEventListener('scroll', function () { if (!ticking) { window.requestAnimationFrame(setScrollState); ticking = true; } }, { passive: true });
  setScrollState();

  function sizeHero() {
    var wraps = document.querySelectorAll('[id*="ss_parallax_banner"]');
    if (!wraps.length) return;
    var r = (SHOP_ROOT || '/').replace(/\/+$/, '') || '/';
    var p = (location.pathname || '/').replace(/\/+$/, '') || '/';
    var isHome = (p === r);
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var heroEl = wrap.querySelector('div');
      if (!heroEl) continue;
      if (isHome && i === 0) {
        var bar = document.querySelector('[id*="ss_scrolling_announcement_bar"]');
        var barH = bar ? bar.offsetHeight : 0;
        var topOffset = wrap.getBoundingClientRect().top + (window.pageYOffset || root.scrollTop || 0);
        var h = window.innerHeight - topOffset - barH;
        if (h < 420) h = 420;
        heroEl.style.height = h + 'px';
      } else {
        heroEl.style.height = Math.min(460, Math.max(280, Math.round(window.innerHeight * 0.38))) + 'px';
      }
    }
  }
  var sizeTick = false;
  function onResize() { if (sizeTick) return; sizeTick = true; window.requestAnimationFrame(function () { sizeHero(); sizeTick = false; }); }
  sizeHero();
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize, { passive: true });
  window.addEventListener('load', sizeHero);

  function initHeaderHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var items = document.querySelectorAll('.header__inline-menu details');
    for (var i = 0; i < items.length; i++) {
      (function (d) {
        if (d.getAttribute('data-mv-hover')) return;
        d.setAttribute('data-mv-hover', '1');
        var sum = d.querySelector('summary');
        var t;
        d.addEventListener('mouseenter', function () { clearTimeout(t); if (!d.hasAttribute('open')) { d.setAttribute('open', ''); if (sum) sum.setAttribute('aria-expanded', 'true'); } });
        d.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); if (sum) sum.setAttribute('aria-expanded', 'false'); }, 120); });
      })(items[i]);
    }
  }

  function initCardIcons() {
    var btns = document.querySelectorAll('.card .quick-add__submit');
    for (var i = 0; i < btns.length; i++) { if (!btns[i].querySelector('.mv-bag')) { btns[i].insertAdjacentHTML('beforeend', BAG_SVG); } }
  }

  function initScrollers() {
    var tracks = document.querySelectorAll('[data-mv-scroller]');
    for (var t = 0; t < tracks.length; t++) {
      (function (track) {
        if (track.getAttribute('data-mv-scroller-ready')) return;
        var parent = track.parentElement;
        if (!parent) return;
        track.setAttribute('data-mv-scroller-ready', '1');
        parent.classList.add('mv-scroll');
        var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'mv-scroll-btn mv-scroll-btn--prev'; prev.setAttribute('aria-label', 'Scroll left');
        var next = document.createElement('button'); next.type = 'button'; next.className = 'mv-scroll-btn mv-scroll-btn--next'; next.setAttribute('aria-label', 'Scroll right');
        parent.appendChild(prev); parent.appendChild(next);
        function amount() { var first = track.firstElementChild; return first ? first.getBoundingClientRect().width * 1.15 : track.clientWidth * 0.8; }
        prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
        function update() { var max = track.scrollWidth - track.clientWidth - 2; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max; }
        track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      })(tracks[t]);
    }
  }

  function initRelated() {
    var grids = document.querySelectorAll('.related-products .product-grid');
    var changed = false;
    for (var i = 0; i < grids.length; i++) { if (!grids[i].getAttribute('data-mv-scroller')) { grids[i].setAttribute('data-mv-scroller', ''); changed = true; } }
    if (changed) initScrollers();
  }

  function mvMoney(cents) {
    try { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents || 0) / 100); }
    catch (e) { return '€' + ((cents || 0) / 100).toFixed(2); }
  }

  var _mvProductCache = {};
  var _mvProduct = null;
  var _mvPriceVaries = false;
  function mvGetProduct(handle) {
    if (_mvProductCache[handle]) return _mvProductCache[handle];
    _mvProductCache[handle] = fetch(SHOP_ROOT + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    return _mvProductCache[handle];
  }
  function mvProductHandle() { var m = window.location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; }
  function mvHandleFromContainer(info) {
    var h = mvProductHandle();
    if (h) return h;
    var link = info && info.querySelector('a[href*="/products/"]');
    if (link) {
      var href = link.getAttribute('href') || '';
      var idx = href.indexOf('/products/');
      if (idx > -1) { var rest = href.slice(idx + 10); var cut = rest.length; ['/', '?', '#'].forEach(function (ch) { var pp = rest.indexOf(ch); if (pp > -1 && pp < cut) cut = pp; }); return rest.slice(0, cut); }
    }
    return null;
  }
  function mvVariantImg(v, product) {
    var src = (v && v.featured_image && v.featured_image.src) || (product && product.featured_image) || (product && product.images && product.images[0]) || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = window.location.protocol + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=140';
  }
  function mvCurrentVariantId(info) {
    var id = null;
    try { id = parseInt(new URL(window.location.href).searchParams.get('variant'), 10); } catch (e) {}
    if (!id) { var hid = info && info.querySelector('form [name="id"]'); if (hid && hid.value) id = parseInt(hid.value, 10); }
    return id;
  }
  function mvSectionId() { var p = document.querySelector('product-info'); return p ? p.getAttribute('data-section') : null; }
  function mvComputeFlags(product) {
    _mvPriceVaries = false;
    if (!product || !product.variants || !product.variants.length) return;
    var p0 = product.variants[0].price, c0 = product.variants[0].compare_at_price || 0;
    for (var i = 1; i < product.variants.length; i++) { if (product.variants[i].price !== p0 || (product.variants[i].compare_at_price || 0) !== c0) { _mvPriceVaries = true; return; } }
  }
  /* Switch variant in place on the product page (no reload) */
  function mvSelectVariant(id) {
    if (!_mvProduct) return;
    var variant = null, i;
    for (i = 0; i < _mvProduct.variants.length; i++) { if (_mvProduct.variants[i].id === id) { variant = _mvProduct.variants[i]; break; } }
    if (!variant) return;
    var sectionId = mvSectionId();
    var ids = document.querySelectorAll('product-info [name="id"], .product__info-container [name="id"]');
    for (i = 0; i < ids.length; i++) { ids[i].value = variant.id; }
    var mg = document.querySelector('media-gallery');
    if (mg && variant.featured_media && typeof mg.setActiveMedia === 'function' && sectionId) {
      try { mg.setActiveMedia(sectionId + '-' + variant.featured_media.id, true); } catch (e) {}
    }
    if (sectionId && _mvPriceVaries) {
      fetch(_mvProduct.url + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var np = doc.getElementById('price-' + sectionId); var cp = document.getElementById('price-' + sectionId);
          if (np && cp) cp.innerHTML = np.innerHTML;
        }).catch(function () {});
    }
    var submit = document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
    if (submit) {
      var span = submit.querySelector('span');
      if (span && !submit.getAttribute('data-mv-atc-text')) submit.setAttribute('data-mv-atc-text', span.textContent.trim());
      if (variant.available) { submit.disabled = false; if (span) span.textContent = submit.getAttribute('data-mv-atc-text') || 'Add to cart'; }
      else { submit.disabled = true; if (span) span.textContent = 'Sold out'; }
    }
    try { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
    var wrap = document.querySelector('.product__info-container .mv-swatches');
    if (wrap) {
      var sws = wrap.querySelectorAll('.mv-swatch');
      for (i = 0; i < sws.length; i++) { sws[i].classList.toggle('is-active', parseInt(sws[i].getAttribute('data-id'), 10) === variant.id); }
      var curEl = wrap.querySelector('.mv-swatches__current'); if (curEl) curEl.textContent = ': ' + variant.title;
    }
    document.dispatchEvent(new CustomEvent('mv:variant', { detail: { id: variant.id } }));
  }
  /* Switch variant inside a quick-add modal (local only) */
  function mvModalSelectVariant(info, product, variantId) {
    var variant = null, i;
    for (i = 0; i < product.variants.length; i++) { if (product.variants[i].id === variantId) { variant = product.variants[i]; break; } }
    if (!variant) return;
    var ids = info.querySelectorAll('[name="id"]');
    for (i = 0; i < ids.length; i++) { ids[i].value = variant.id; }
    var scope = (info.closest && info.closest('.quick-add-modal__content')) || info;
    var img = scope.querySelector('.product__media img, .media img, img.product__media-item, .quick-add-modal__content img');
    if (img && variant.featured_image) { var s = variant.featured_image.src; if (s.indexOf('//') === 0) s = window.location.protocol + s; img.src = s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=420'; }
    var wrap = info.querySelector('.mv-swatches');
    if (wrap) { var sws = wrap.querySelectorAll('.mv-swatch'); for (i = 0; i < sws.length; i++) { sws[i].classList.toggle('is-active', parseInt(sws[i].getAttribute('data-id'), 10) === variant.id); } var cur = wrap.querySelector('.mv-swatches__current'); if (cur) cur.textContent = ': ' + variant.title; }
    var submit = info.querySelector('.product-form__submit');
    if (submit) { submit.disabled = !variant.available; var span = submit.querySelector('span'); if (span && !variant.available) span.textContent = 'Sold out'; }
  }

  /* Native variant image-swatches (product pages AND quick-add modal) */
  function initVariantSwatches() {
    var infos = document.querySelectorAll('.product__info-container');
    for (var i = 0; i < infos.length; i++) {
      (function (info) {
        if (info.querySelector('.mv-swatches')) return;
        var handle = mvHandleFromContainer(info);
        if (!handle) return;
        mvGetProduct(handle).then(function (p) { buildSwatches(info, p); }).catch(function () {});
      })(infos[i]);
    }
  }
  function buildSwatches(info, product) {
    var variants = (product && product.variants) || [];
    if (variants.length < 2 || info.querySelector('.mv-swatches')) return;
    var inModal = !!(info.closest && info.closest('quick-add-modal, .quick-add-modal, modal-dialog'));
    if (!inModal) { _mvProduct = product; mvComputeFlags(product); }
    var curId = mvCurrentVariantId(info);
    if (inModal) { var hid = info.querySelector('[name="id"]'); if (hid && hid.value) curId = parseInt(hid.value, 10); }
    var optName = (product.options && product.options[0] && (product.options[0].name || product.options[0])) || '';
    var wrap = document.createElement('div');
    wrap.className = 'mv-swatches';
    var html = '<p class="mv-swatches__label">' + optName + '<span class="mv-swatches__current"></span></p><div class="mv-swatches__row">';
    variants.forEach(function (v) {
      var imgUrl = mvVariantImg(v, product);
      html += '<a class="mv-swatch' + (v.id === curId ? ' is-active' : '') + (v.available ? '' : ' is-soldout') + '" href="' + product.url + '?variant=' + v.id + '" data-id="' + v.id + '" data-title="' + ('' + v.title).replace(/"/g, '&quot;') + '" aria-label="' + ('' + v.title).replace(/"/g, '&quot;') + '">' + (imgUrl ? '<img src="' + imgUrl + '" alt="" width="56" height="56">' : '') + '</a>';
    });
    html += '</div>';
    wrap.innerHTML = html;
    var anchor = info.querySelector('product-form') || info.querySelector('.product-form') || info.querySelector('.product-form__buttons') || info.querySelector('.product-form__quantity');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor); else info.appendChild(wrap);
    var cur = variants.filter(function (v) { return v.id === curId; })[0] || variants[0];
    var curEl = wrap.querySelector('.mv-swatches__current');
    function setLabel(t) { if (curEl) curEl.textContent = t ? (': ' + t) : ''; }
    setLabel(cur ? cur.title : '');
    wrap.addEventListener('click', function (e) {
      var s = e.target.closest('.mv-swatch'); if (!s) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      var vid = parseInt(s.getAttribute('data-id'), 10);
      if (inModal) mvModalSelectVariant(info, product, vid); else mvSelectVariant(vid);
    });
    wrap.addEventListener('mouseover', function (e) { var s = e.target.closest('.mv-swatch'); if (s) setLabel(s.getAttribute('data-title')); });
    wrap.addEventListener('mouseleave', function () { var a = wrap.querySelector('.mv-swatch.is-active'); setLabel(a ? a.getAttribute('data-title') : ''); });
  }
  /* Re-run swatch init when a quick-add modal opens (content loads async) */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest && e.target.closest('.card .quick-add__submit');
    if (!qa || !qa.closest('modal-opener')) return;
    window.setTimeout(initVariantSwatches, 450);
    window.setTimeout(initVariantSwatches, 1100);
    window.setTimeout(initVariantSwatches, 2100);
  });

  /* Sticky add-to-cart on product pages */
  function initStickyAtc() {
    var info = document.querySelector('.product__info-container');
    if (!info || document.querySelector('.mv-sticky-atc')) return;
    var handle = mvProductHandle();
    if (!handle) return;
    mvGetProduct(handle).then(function (product) { buildStickyAtc(info, product); }).catch(function () {});
  }
  function buildStickyAtc(info, product) {
    var variants = (product && product.variants) || [];
    if (!variants.length || document.querySelector('.mv-sticky-atc')) return;
    _mvProduct = product; mvComputeFlags(product);
    var multi = variants.length > 1;
    var selected = null, i;
    var initialId = mvCurrentVariantId(info);
    if (initialId) { for (i = 0; i < variants.length; i++) { if (variants[i].id === initialId) { selected = variants[i]; break; } } }
    if (!selected) { for (i = 0; i < variants.length; i++) { if (variants[i].available) { selected = variants[i]; break; } } }
    if (!selected) selected = variants[0];
    var qty = 1;
    var bar = document.createElement('div');
    bar.className = 'mv-sticky-atc';
    bar.innerHTML = ''
      + '<div class="mv-sticky-atc__inner">'
      +   '<a class="mv-sticky-atc__media" href="' + product.url + '"><img alt=""></a>'
      +   '<div class="mv-sticky-atc__info"><span class="mv-sticky-atc__title"></span><span class="mv-sticky-atc__price"></span></div>'
      +   (multi ? '<button type="button" class="mv-sticky-atc__variant" aria-haspopup="true" aria-expanded="false"><span class="mv-sticky-atc__variant-label"></span><span class="mv-sticky-atc__caret"></span></button>' : '')
      +   '<div class="mv-sticky-atc__qty"><button type="button" class="mv-sticky-atc__qbtn" data-d="-1" aria-label="Decrease">−</button><span class="mv-sticky-atc__qval">1</span><button type="button" class="mv-sticky-atc__qbtn" data-d="1" aria-label="Increase">+</button></div>'
      +   '<button type="button" class="button button--primary mv-sticky-atc__btn">Add to cart</button>'
      +   (multi ? '<div class="mv-sticky-atc__pop" hidden></div>' : '')
      + '</div>';
    document.body.appendChild(bar);
    var imgEl = bar.querySelector('.mv-sticky-atc__media img');
    var titleEl = bar.querySelector('.mv-sticky-atc__title');
    var priceEl = bar.querySelector('.mv-sticky-atc__price');
    var varBtn = bar.querySelector('.mv-sticky-atc__variant');
    var varLabel = bar.querySelector('.mv-sticky-atc__variant-label');
    var pop = bar.querySelector('.mv-sticky-atc__pop');
    var qval = bar.querySelector('.mv-sticky-atc__qval');
    var addBtn = bar.querySelector('.mv-sticky-atc__btn');
    titleEl.textContent = product.title;
    var syncChips = function () {};
    function render() {
      var s = mvVariantImg(selected, product); if (imgEl && s) imgEl.src = s;
      if (priceEl) priceEl.textContent = mvMoney(selected.price);
      if (varLabel) varLabel.textContent = selected.title;
      qval.textContent = qty;
      if (selected.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
      else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
    }
    if (multi && pop) {
      var html = '';
      (product.options || []).forEach(function (optName, idx) {
        var vals = [];
        variants.forEach(function (v) { var val = v.options[idx]; if (vals.indexOf(val) === -1) vals.push(val); });
        html += '<div class="mv-sticky-atc__opt"><span class="mv-sticky-atc__opt-name">' + (optName && optName.name ? optName.name : optName) + '</span><div class="mv-sticky-atc__opt-vals">';
        vals.forEach(function (val) { html += '<button type="button" class="mv-sticky-atc__chip" data-opt="' + idx + '" data-val="' + ('' + val).replace(/"/g, '&quot;') + '">' + val + '</button>'; });
        html += '</div></div>';
      });
      pop.innerHTML = html;
      syncChips = function () {
        var chips = pop.querySelectorAll('.mv-sticky-atc__chip');
        for (var c = 0; c < chips.length; c++) { var oi = parseInt(chips[c].getAttribute('data-opt'), 10); chips[c].classList.toggle('is-active', selected.options[oi] === chips[c].getAttribute('data-val')); }
      };
      pop.addEventListener('click', function (e) {
        var chip = e.target.closest('.mv-sticky-atc__chip'); if (!chip) return;
        var oi = parseInt(chip.getAttribute('data-opt'), 10); var val = chip.getAttribute('data-val');
        var desired = selected.options.slice(); desired[oi] = val;
        var match = null, j;
        for (j = 0; j < variants.length; j++) { if (variants[j].options.join('~~') === desired.join('~~')) { match = variants[j]; break; } }
        if (!match) { for (j = 0; j < variants.length; j++) { if (variants[j].options[oi] === val && variants[j].available) { match = variants[j]; break; } } }
        if (!match) { for (j = 0; j < variants.length; j++) { if (variants[j].options[oi] === val) { match = variants[j]; break; } } }
        if (match) { mvSelectVariant(match.id); }
      });
      varBtn.addEventListener('click', function () {
        if (pop.hasAttribute('hidden')) { pop.removeAttribute('hidden'); varBtn.setAttribute('aria-expanded', 'true'); syncChips(); }
        else { pop.setAttribute('hidden', ''); varBtn.setAttribute('aria-expanded', 'false'); }
      });
      document.addEventListener('click', function (e) { if (!bar.contains(e.target)) { pop.setAttribute('hidden', ''); varBtn.setAttribute('aria-expanded', 'false'); } });
    }
    document.addEventListener('mv:variant', function (e) {
      var v = null, k;
      for (k = 0; k < variants.length; k++) { if (variants[k].id === e.detail.id) { v = variants[k]; break; } }
      if (v) { selected = v; render(); syncChips(); }
    });
    var qbtns = bar.querySelectorAll('.mv-sticky-atc__qbtn');
    for (i = 0; i < qbtns.length; i++) { (function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty + parseInt(b.getAttribute('data-d'), 10)); qval.textContent = qty; }); })(qbtns[i]); }
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch(SHOP_ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: selected.id, quantity: qty }], sections: 'cart-drawer', sections_url: window.location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (data) { mvRefreshDrawer(data && data.sections && data.sections['cart-drawer']); qty = 1; render(); })
        .catch(function () { render(); });
    });
    render();
    var anchor = info.querySelector('.product-form__submit') || info.querySelector('.product-form__buttons') || info.querySelector('.product-form');
    if ('IntersectionObserver' in window && anchor) {
      var io = new IntersectionObserver(function (entries) { bar.classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: 0 });
      io.observe(anchor);
    } else { bar.classList.add('is-visible'); }
  }

  /* Cart: setting quantity to 0 removes the item */
  function mvRemoveRow(node) {
    var scope = node.closest('quantity-popover') || node.closest('.cart-item') || node.closest('tr') || node.closest('td');
    var remove = scope && scope.querySelector('cart-remove-button button, .cart-remove-button');
    if (remove) { remove.click(); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('.quantity__button[name="minus"]');
    if (!minus || !minus.closest('#CartDrawer, cart-drawer, cart-items, cart-drawer-items')) return;
    var qi = minus.closest('quantity-input');
    var input = qi && qi.querySelector('.quantity__input');
    if (input && parseInt(input.value, 10) <= 1) { e.preventDefault(); e.stopPropagation(); mvRemoveRow(minus); }
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.quantity__input');
    if (!input || !input.closest('#CartDrawer, cart-drawer, cart-items, cart-drawer-items')) return;
    if (input.value === '' || parseInt(input.value, 10) <= 0) { mvRemoveRow(input); }
  }, true);

  function mvEnsureRecsStyle() {
    if (document.getElementById('mv-recs-style')) return;
    var s = document.createElement('style'); s.id = 'mv-recs-style';
    s.textContent = ".mv-cart-recs:empty{display:none}.mv-cart-recs{width:100%;max-width:100%;min-width:0;overflow:hidden}.mv-recs{width:100%;max-width:100%;min-width:0;padding:1.6rem 0 0.4rem;margin-top:1.4rem;border-top:.1rem solid rgba(var(--mv-forest),.14)}.mv-recs__title{font-family:var(--font-heading-family);font-size:1.7rem;letter-spacing:-.01em;margin:0 0 1.2rem;color:rgb(var(--mv-forest))}.mv-recs__track{display:flex;gap:1.2rem;width:100%;max-width:100%;min-width:0;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:.6rem;scrollbar-width:thin}.mv-rec{flex:0 0 11.5rem;scroll-snap-align:start;display:flex;flex-direction:column;gap:.7rem}.mv-rec__media{display:block;aspect-ratio:1/1;overflow:hidden;background:rgba(var(--mv-forest),.05)}.mv-rec__media img{width:100%;height:100%;object-fit:cover;transition:transform .8s var(--mv-ease)}.mv-rec__media:hover img{transform:scale(1.05)}.mv-rec__info{display:flex;flex-direction:column;gap:.2rem;flex:1 1 auto}.mv-rec__title{font-family:var(--font-heading-family);font-size:1.35rem;line-height:1.2;color:rgb(var(--mv-forest));text-decoration:none}.mv-rec__price{font-size:1.25rem;color:rgba(var(--mv-forest),.7)}.mv-rec__add.button{min-height:0;padding:.9rem 1rem;font-size:1.05rem;--color-button:var(--mv-gold);--color-button-text:var(--mv-forest)}";
    document.head.appendChild(s);
  }
  function mvRenderRecs(holder, products) {
    var frag = '<div class="mv-recs"><p class="mv-recs__title">You may also like</p><div class="mv-recs__track" data-mv-scroller>';
    var n = 0;
    products.forEach(function (p) {
      var v = null, i;
      for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
      if (!v) return;
      n++;
      var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240') : '';
      frag += '<div class="mv-rec"><a class="mv-rec__media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a><div class="mv-rec__info"><a class="mv-rec__title" href="' + p.url + '">' + p.title + '</a><span class="mv-rec__price">' + mvMoney(v.price) + '</span></div><button type="button" class="button mv-rec__add" data-vid="' + v.id + '">Add</button></div>';
    });
    frag += '</div></div>';
    if (n) { holder.innerHTML = frag; initScrollers(); }
  }
  function mvFetchRecs(pid, intent) { return fetch(SHOP_ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=' + intent).then(function (r) { return r.json(); }); }
  function initCartRecs() {
    var holder = document.querySelector('[data-mv-recs]');
    if (!holder || holder.getAttribute('data-loaded')) return;
    var pid = holder.getAttribute('data-pid');
    if (!pid) return;
    holder.setAttribute('data-loaded', '1');
    mvEnsureRecsStyle();
    mvFetchRecs(pid, 'complementary').then(function (data) {
      var products = (data && data.products) || [];
      if (products.length) { mvRenderRecs(holder, products); return; }
      return mvFetchRecs(pid, 'related').then(function (d2) { mvRenderRecs(holder, (d2 && d2.products) || []); });
    }).catch(function () {});
  }
  function mvRefreshDrawer(html) {
    var cd = document.querySelector('cart-drawer');
    if (html) {
      var temp = document.createElement('div'); temp.innerHTML = html;
      var ni = temp.querySelector('.drawer__inner'); var ci = document.querySelector('#CartDrawer .drawer__inner');
      if (ni && ci) ci.replaceWith(ni);
      if (cd) cd.classList.remove('is-empty');
    }
    if (cd && typeof cd.open === 'function') { try { cd.open(); } catch (e) {} }
    initCartRecs(); initScrollers();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mv-rec__add');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-vid');
    if (!vid || btn.disabled) return;
    btn.disabled = true; btn.textContent = 'Adding';
    fetch(SHOP_ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (data) { mvRefreshDrawer(data && data.sections && data.sections['cart-drawer']); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
  });

  function mvInit() { initHeaderHover(); initCardIcons(); initRelated(); initVariantSwatches(); initStickyAtc(); initCartRecs(); initScrollers(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', mvInit); } else { mvInit(); }
  document.addEventListener('shopify:section:load', mvInit);
  window.setTimeout(function () { initCardIcons(); initRelated(); }, 700);
  window.setTimeout(function () { initCardIcons(); initRelated(); }, 1800);
  var cdEl = document.querySelector('cart-drawer');
  if (cdEl && 'MutationObserver' in window) { var rt; var mo = new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(mvInit, 160); }); mo.observe(cdEl, { childList: true, subtree: true }); }
  if ('MutationObserver' in window) {
    var recEls = document.querySelectorAll('.related-products, .complementary-products');
    for (var r = 0; r < recEls.length; r++) { (function (el) { var ro = new MutationObserver(function () { initCardIcons(); initRelated(); }); ro.observe(el, { childList: true, subtree: true }); })(recEls[r]); }
    var qmt; var qm = new MutationObserver(function () { clearTimeout(qmt); qmt = setTimeout(function () { initCardIcons(); initVariantSwatches(); }, 180); }); qm.observe(document.body, { childList: true, subtree: true });
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('mv-anim');
  var observer = new IntersectionObserver(function (entries) { for (var i = 0; i < entries.length; i++) { if (entries[i].isIntersecting) { entries[i].target.classList.add('mv-in'); observer.unobserve(entries[i].target); } } }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function prepare() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = main.children;
    var vh = window.innerHeight || root.clientHeight;
    var idx = 0;
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      if (!section.className || String(section.className).indexOf('shopify-section') === -1) continue;
      if (section.classList.contains('mv-reveal') || section.classList.contains('mv-in')) { idx++; continue; }
      if (section.querySelector('.scroll-trigger')) { section.classList.add('mv-in'); idx++; continue; }
      var rect = section.getBoundingClientRect();
      if (idx === 0 || rect.top < vh * 0.85) { section.classList.add('mv-in'); }
      else { section.classList.add('mv-reveal'); observer.observe(section); }
      idx++;
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', prepare); } else { prepare(); }
  document.addEventListener('shopify:section:load', prepare);
})();
